import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { ProductModel } from '../../../product/product.model';
import { ProductHeaderComponent } from '@common/product-header/product-header.component';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

interface IDialogData {
  skuId: string;
}

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  imports: [ImageLoadingComponent, MatDialogModule, ProductHeaderComponent, FocusRemoverDirective],
  providers: [ProductModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailComponent implements OnInit {
  public data: IDialogData = inject(MAT_DIALOG_DATA);
  public viewModel = inject(ProductModel);

  private readonly destroyRef = inject(DestroyRef);

  static open(dialog: MatDialog, skuId: string): MatDialogRef<ProductDetailComponent> {
    const data: IDialogData = { skuId };
    return dialog.open(ProductDetailComponent, {
      data,
      width: '1100px',
      minHeight: '634px',
      disableClose: true,
    });
  }

  ngOnInit(): void {
    this.viewModel.getProduct(this.destroyRef, this.data.skuId);
  }
}
